import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraButton } from '../ensigns/button';
/** Small mutually-exclusive view or mode selector. */ export function SpecraSegmentedControl({ className, label, onValueChange, options, size = 'default', testId, value }) {
    return /*#__PURE__*/ _jsxs("fieldset", {
        className: cn('inline-flex max-w-full overflow-x-auto rounded-md bg-muted p-0.5 [scrollbar-width:thin]', className),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx("legend", {
                className: "sr-only",
                children: label
            }),
            options.map((option)=>{
                const active = option.value === value;
                return /*#__PURE__*/ _jsxs(SpecraButton, {
                    "aria-pressed": active,
                    className: cn('shrink-0 border-transparent', size === 'sm' ? 'h-[var(--control-height-sm)] px-2.5' : 'h-7 px-3', active ? 'bg-card text-foreground shadow-sm' : 'text-muted-foreground'),
                    "data-active": active || undefined,
                    "data-testid": option.testId,
                    "data-value": option.value,
                    disabled: option.disabled,
                    onClick: ()=>onValueChange(option.value),
                    size: size === 'sm' ? 'sm' : undefined,
                    variant: "ghost",
                    children: [
                        /*#__PURE__*/ _jsx(React.Fragment, {
                            children: option.label
                        }, "label"),
                        option.count !== undefined ? /*#__PURE__*/ _jsx("span", {
                            className: "tabular-nums text-muted-foreground",
                            children: option.count
                        }, "count") : null
                    ]
                }, option.value);
            })
        ]
    });
}
